import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { ViewController, NavParams, Events } from 'ionic-angular';

// Providers 
import { InstructorsService } from '../../providers/instructors/instructors-service';
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  templateUrl: 'certification.modal.html'
})

export class CertificationModalPage
{
  edit: boolean = false;
  modalTitle: string = 'New Certification';
  certification: any = {};
  instructor: any = {};
  dateRange: any = {};

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public instructorsService: InstructorsService,
    public helperService: HelperService,
    public events: Events
  ) {
    this.dateRange = this.helperService.getYearRange();
    let instructors = this.navParams.get('instructors');
    this.instructor = instructors[0];

    // Look for certification record with date_issued.  If one exists,
    // then pre-slug the date_issued field in the form. 
    this.checkCertificationsForDateIssued();

    if ( this.navParams.get('edit') === true )
    {
      this.edit = true;
      this.modalTitle = 'Edit Certification';
      this.certification = this.navParams.get('editData');
    }
  }

  saveCertification()
  {
    this.certification.instructor_id = this.instructor.instructor_id;
    this.instructorsService.saveCertification( this.certification )
      .subscribe( data => {
        if ( this.edit === false )
        {
          this.instructor.certifications.push( data );
        }
        this.events.publish('app:log', {
          message: 'Instructor certification saved.',
          status: 'success',
          type: 'save instructor certification'
        });
    },
    error => {
      this.helperService.showErrors( error );
    });
    this.dismissModal();
  }

  checkCertificationsForDateIssued()
  {
    for ( let cert of this.instructor.certifications )
    {
      if ( cert.date_issued !== '0001-01-01' )
      {
        this.certification.date_issued = cert.date_issued;
      }
    }
  }

  dismissModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/certification.modal.ts